import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class TasksService {
  private url = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getRule(integration_id: number) {
    return this.http.get(`${this.url}/rules/${integration_id}`);
  }

  runRule(
    integrationIds: number | number[],
    options?: { days_from_checkin?: string }
  ) {
    const ids = Array.isArray(integrationIds)
      ? integrationIds.join(',')
      : String(integrationIds);
    const formData = new FormData();
    formData.append('integration_ids', ids);
    formData.append('days_from_checkin', options?.days_from_checkin ?? '');
    return this.http.post<{
      data: { integration_id: number; task_arn: string }[];
      errors: unknown[];
      status: string;
    }>(`${this.url}/rules/run`, formData);
  }

  updateTask(integration_id: number | null | undefined, payload: any) {
    return this.http.put(`${this.url}/rules/${integration_id}`, payload);
  }

  createTask(payload: any) {
    return this.http.post(`${this.url}/rules`, payload);
  }
}
